module.exports = __webpack_public_path__ + "static/media/apple.ff133c97.svg";